import { type Client, graphql, prefetch } from "@opensea/graphql"
import { CollectionItemsActionsFragment } from "./CollectionItemsActions.fragment"
import { MobileCollectionItemsActionsFragment } from "./MobileCollectionItemsActions.fragment"

export const CollectionItemsActionBarBaseFragment = graphql(
  `
    fragment CollectionItemsActionBarBase on Collection {
      slug
      ...CollectionItemsActions
      ...MobileCollectionItemsActions
    }
  `,
  [CollectionItemsActionsFragment, MobileCollectionItemsActionsFragment],
)

export const CollectionItemsActionBarQuery = graphql(
  `
    query CollectionItemsActionBarQuery($collectionSlug: String!) {
      collectionBySlug(slug: $collectionSlug) {
        __typename
        ... on Collection {
          id
          enforcement {
            isDisabled
          }
          ...CollectionItemsActionBarBase
        }
        ... on DelistedCollection {
          id
        }
        ... on BlacklistedCollection {
          id
        }
      }
    }
  `,
  [CollectionItemsActionBarBaseFragment],
)

export const prefetchCollectionItemsActionBarQuery = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionItemsActionBarQuery, { collectionSlug })
}
